<template>
  <v-navigation-drawer
    v-model="drawer"
    temporary
    right
    width="450"
    height="100%"
    app
  >
    <v-card flat>
      <v-card-title> Core Product </v-card-title>
      <v-card-subtitle> Add your new core product here </v-card-subtitle>
      <v-card-text>
        <ProductForm @save="save" />
      </v-card-text>
    </v-card>
    <template #append>
      <v-divider />
      <v-card-text>
        <PortalTarget :name="getDrawerAppend($enums.DRAWER.EDIT_PRODUCT)">
          <slot name="append" />
        </PortalTarget>
      </v-card-text>
    </template>
  </v-navigation-drawer>
</template>

<script>
import ProductForm from '@/components/products/Form';
import { mapGetters } from 'vuex';

export default {
  name: 'EditProduct',

  components: {
    ProductForm
  },

  data() {
    return {
      loading: false,
      valid: false,
      saving: false,
      drawer: false,
      tab: 0,
      generating: false,
      addResizeCoreProductId: null,
      printProductId: null
    };
  },

  computed: {
    product: {
      get() {
        return this.$store.getters['products/edit_product'];
      },
      set(val) {
        this.$store.dispatch('products/edit', val);
      }
    },
    ...mapGetters({
      products: 'lookup/standard_products'
    })
  },

  async mounted() {
    this.$bus.$off(this.$enums.EVENT_BUS_EVENTS.ADD_CORE_PRODUCT_SHOW);
    this.$bus.$on(this.$enums.EVENT_BUS_EVENTS.ADD_CORE_PRODUCT_SHOW, (data) => {
      this.loadData(data.categoryId, data.height, data.width, data.printProductId);
      this.tab = 0;
      this.drawer = true;
    });
  },

  methods: {
    loadData(categoryId, height, width, printProductId) {
      this.loading = true;

      this.printProductId = printProductId;
      let size = '';
      if (height && width) {
        size = `${height}" x ${width}"`;
      }
      const calls = [];
      calls.push(
        this.$store.dispatch('products/set', {
          category: {
            id: categoryId
          },
          active: true,
          sizeDisplay: size,
          units: { id: this.$enums.UNITS.INCHES },
          fold: { id: this.$enums.FOLD_TYPE.NONE },
          height: height,
          width: width
        })
      );
      calls.push(this.$store.dispatch('guides/resetList'));
      calls.push(this.$store.dispatch('outputs/resetList'));
      Promise.all(calls)
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    async save(id) {
      if (this.printProductId) {
        await this.$store.dispatch('print/connect', {
          printProductId: this.printProductId,
          coreProductId: id
        });
      }
      this.drawer = false;
      this.$emit('save');
    }
  }
};
</script>
